import firebase from 'firebase';

const firebaseConfig = {
  apiKey: "AIzaSyCitg-S2trgmTb3qxzmJbGw1aEui-eHJns",
  authDomain: "swasthmindptsd-6b81b.firebaseapp.com",
  projectId: "swasthmindptsd-6b81b",
  storageBucket: "swasthmindptsd-6b81b.appspot.com",
  messagingSenderId: "774660918216",
  appId: "1:774660918216:web:524b9e488a0ee3ae328efd",
  measurementId: "G-1B47J8VWCQ"
};
const firebaseApp = firebase.initializeApp(firebaseConfig);

const db = firebaseApp.firestore();

const auth = firebaseApp.auth();

export { db, auth };